/**
 * @generated SignedSource<<4dc5d48cc1ec956db86d0591cfd952c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountKeyId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "direction"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endTs"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "keyName"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "keyValue"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requestEndpoint"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requestMethod"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "responseCode"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceIp"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startTs"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userAgent"
},
v14 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  },
  {
    "kind": "Variable",
    "name": "accountKeyId",
    "variableName": "accountKeyId"
  },
  {
    "kind": "Variable",
    "name": "direction",
    "variableName": "direction"
  },
  {
    "kind": "Variable",
    "name": "endTs",
    "variableName": "endTs"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "keyName",
    "variableName": "keyName"
  },
  {
    "kind": "Variable",
    "name": "keyValue",
    "variableName": "keyValue"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "requestEndpoint",
    "variableName": "requestEndpoint"
  },
  {
    "kind": "Variable",
    "name": "requestMethod",
    "variableName": "requestMethod"
  },
  {
    "kind": "Variable",
    "name": "responseCode",
    "variableName": "responseCode"
  },
  {
    "kind": "Variable",
    "name": "sourceIp",
    "variableName": "sourceIp"
  },
  {
    "kind": "Variable",
    "name": "startTs",
    "variableName": "startTs"
  },
  {
    "kind": "Variable",
    "name": "userAgent",
    "variableName": "userAgent"
  }
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aklId",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountKeyId",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "keyName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "keyValue",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestId",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestEndpoint",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestMethod",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestBody",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourceIp",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userAgent",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "responseCode",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "responseBody",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ResellerApiLogTableQuery",
    "selections": [
      {
        "alias": null,
        "args": (v14/*: any*/),
        "concreteType": "AccountKeyLogTsConnection",
        "kind": "LinkedField",
        "name": "getresellerapikeylogs",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountKeyLogT",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v12/*: any*/),
      (v3/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/),
      (v11/*: any*/),
      (v13/*: any*/),
      (v10/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "ResellerApiLogTableQuery",
    "selections": [
      {
        "alias": null,
        "args": (v14/*: any*/),
        "concreteType": "AccountKeyLogTsConnection",
        "kind": "LinkedField",
        "name": "getresellerapikeylogs",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountKeyLogT",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1a1a702f08a109ce47885ee95572cdb1",
    "id": null,
    "metadata": {},
    "name": "ResellerApiLogTableQuery",
    "operationKind": "query",
    "text": "query ResellerApiLogTableQuery(\n  $accountId: UUID\n  $accountKeyId: UUID\n  $keyName: String\n  $keyValue: String\n  $startTs: Datetime\n  $endTs: Datetime\n  $requestMethod: String\n  $requestEndpoint: String\n  $sourceIp: String\n  $userAgent: String\n  $responseCode: [Int]\n  $direction: Int\n  $first: Int\n  $offset: Int\n) {\n  getresellerapikeylogs(accountId: $accountId, accountKeyId: $accountKeyId, keyName: $keyName, keyValue: $keyValue, startTs: $startTs, endTs: $endTs, requestMethod: $requestMethod, requestEndpoint: $requestEndpoint, sourceIp: $sourceIp, userAgent: $userAgent, responseCode: $responseCode, direction: $direction, first: $first, offset: $offset) {\n    totalCount\n    nodes {\n      created\n      aklId\n      accountId\n      accountKeyId\n      keyName\n      keyValue\n      requestId\n      requestEndpoint\n      requestMethod\n      requestBody\n      sourceIp\n      userAgent\n      responseCode\n      responseBody\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "3adf8709daa8f545f4477b94c7b095b5";

module.exports = node;
